module.exports = __webpack_public_path__ + "img/02-rocket.5ec534c6.png";